import React from 'react';
import PropTypes from 'prop-types';
import Shoutbox from './Shoutbox.container';
import Content from './content';
import Wrapper from './wrapper';

import { isComponentFullScreen, isComponentVisible, shouldComponentBeDeleted } from './utils';

class ShoutBoxVisualization extends React.Component {
	static propTypes = {
		messages: PropTypes.arrayOf(PropTypes.shape({
			id: PropTypes.string,
			message: PropTypes.string,
			user: PropTypes.object,
		})),
	};

	static defaultProps = {
		messages: null,
	};

	constructor() {
		super();
		this.isComponentFullScreen = isComponentFullScreen.bind(this);
		this.isComponentVisible = isComponentVisible.bind(this);
		this.shouldComponentBeDeleted = shouldComponentBeDeleted.bind(this);
	}

	render() {
		const { messages } = this.props;
		return (
			<Wrapper>
				<Content>
					{
						messages.map((message, idx) => {
							const { content, user: { name, username, firstName }, id } = message;
							return (
								<Shoutbox
									willBeDeleted={this.shouldComponentBeDeleted(id)}
									show={this.isComponentVisible(id)}
									fullscreen={this.isComponentFullScreen(id)}
									message={content.text}
									user={content.username || username || firstName || name}
									key={id}
									id={id}
									idx={idx}
									messageCount={messages.length}
								/>
							);
						})
					}
				</Content>
			</Wrapper>
		);
	}
}

export default ShoutBoxVisualization;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/shoutboxvisualization/ShoutboxVisualization.component.js